export const VendorMenuList = [
	// Booking
	{
		title: "Booking",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				fill="none"
				stroke="#FFF"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
				viewBox="0 0 24 24">
				<rect x="3" y="4" width="18" height="18" rx="2"></rect>
				<line x1="16" y1="2" x2="16" y2="6"></line>
				<line x1="8" y1="2" x2="8" y2="6"></line>
				<line x1="3" y1="10" x2="21" y2="10"></line>
				<circle cx="12" cy="15" r="2"></circle>
			</svg>
		),
		iconDeactive: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				fill="none"
				stroke="#000"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
				viewBox="0 0 24 24">
				<rect x="3" y="4" width="18" height="18" rx="2"></rect>
				<line x1="16" y1="2" x2="16" y2="6"></line>
				<line x1="8" y1="2" x2="8" y2="6"></line>
				<line x1="3" y1="10" x2="21" y2="10"></line>
				<circle cx="12" cy="15" r="2"></circle>
			</svg>
		),
		to: "/vendor/bookings",
		text: "bookings",
		role: "bookings",
	},
	// Orders
	{
		title: "Orders",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="22"
				height="22"
				viewBox="0 0 24 24"
				stroke="#FFF"
				fill="none"
				strokeWidth="2">
				<circle cx="9" cy="21" r="1" />
				<circle cx="20" cy="21" r="1" />
				<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
			</svg>
		),
		iconDeactive: (
			<svg
				width="22"
				height="22"
				viewBox="0 0 24 24"
				stroke="#000"
				fill="none"
				strokeWidth="2">
				<circle cx="9" cy="21" r="1" />
				<circle cx="20" cy="21" r="1" />
				<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
			</svg>
		),
		to: "/vendor/orders",
		text: "orders",
		role: "orders",
	},
	// Products
	{
		title: "Products",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M18.3333 6.8915V3.52484C18.3333 2.19984 17.8 1.6665 16.475 1.6665H13.1083C11.7833 1.6665 11.25 2.19984 11.25 3.52484V6.8915C11.25 8.2165 11.7833 8.74984 13.1083 8.74984H16.475C17.8 8.74984 18.3333 8.2165 18.3333 6.8915Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.75001 7.09984V3.3165C8.75001 2.1415 8.21667 1.6665 6.89167 1.6665H3.52501C2.20001 1.6665 1.66667 2.1415 1.66667 3.3165V7.0915C1.66667 8.27484 2.20001 8.7415 3.52501 8.7415H6.89167C8.21667 8.74984 8.75001 8.27484 8.75001 7.09984Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.75001 16.475V13.1083C8.75001 11.7833 8.21667 11.25 6.89167 11.25H3.52501C2.20001 11.25 1.66667 11.7833 1.66667 13.1083V16.475C1.66667 17.8 2.20001 18.3333 3.52501 18.3333H6.89167C8.21667 18.3333 8.75001 17.8 8.75001 16.475Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.0833 14.5835H17.0833"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
				/>
				<path
					d="M14.5833 17.0835V12.0835"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M18.3333 6.8915V3.52484C18.3333 2.19984 17.8 1.6665 16.475 1.6665H13.1083C11.7833 1.6665 11.25 2.19984 11.25 3.52484V6.8915C11.25 8.2165 11.7833 8.74984 13.1083 8.74984H16.475C17.8 8.74984 18.3333 8.2165 18.3333 6.8915Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.75001 7.09984V3.3165C8.75001 2.1415 8.21667 1.6665 6.89167 1.6665H3.52501C2.20001 1.6665 1.66667 2.1415 1.66667 3.3165V7.0915C1.66667 8.27484 2.20001 8.7415 3.52501 8.7415H6.89167C8.21667 8.74984 8.75001 8.27484 8.75001 7.09984Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.75001 16.475V13.1083C8.75001 11.7833 8.21667 11.25 6.89167 11.25H3.52501C2.20001 11.25 1.66667 11.7833 1.66667 13.1083V16.475C1.66667 17.8 2.20001 18.3333 3.52501 18.3333H6.89167C8.21667 18.3333 8.75001 17.8 8.75001 16.475Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.0833 14.5835H17.0833"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
				/>
				<path
					d="M14.5833 17.0835V12.0835"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
				/>
			</svg>
		),
		to: "vendor/products",
		text: "products",
		role: "",
	},
];
export const MenuList = [
	// Dashboard
	{
		title: "Dashboard",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M14.1667 8.33329H15.8333C17.5 8.33329 18.3333 7.49996 18.3333 5.83329V4.16663C18.3333 2.49996 17.5 1.66663 15.8333 1.66663H14.1667C12.5 1.66663 11.6667 2.49996 11.6667 4.16663V5.83329C11.6667 7.49996 12.5 8.33329 14.1667 8.33329Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M4.16667 18.3333H5.83333C7.5 18.3333 8.33333 17.5 8.33333 15.8333V14.1666C8.33333 12.5 7.5 11.6666 5.83333 11.6666H4.16667C2.5 11.6666 1.66667 12.5 1.66667 14.1666V15.8333C1.66667 17.5 2.5 18.3333 4.16667 18.3333Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M5 8.33329C6.84095 8.33329 8.33333 6.84091 8.33333 4.99996C8.33333 3.15901 6.84095 1.66663 5 1.66663C3.15905 1.66663 1.66667 3.15901 1.66667 4.99996C1.66667 6.84091 3.15905 8.33329 5 8.33329Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M15 18.3333C16.8409 18.3333 18.3333 16.8409 18.3333 15C18.3333 13.159 16.8409 11.6666 15 11.6666C13.1591 11.6666 11.6667 13.159 11.6667 15C11.6667 16.8409 13.1591 18.3333 15 18.3333Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M14.1667 8.33329H15.8333C17.5 8.33329 18.3333 7.49996 18.3333 5.83329V4.16663C18.3333 2.49996 17.5 1.66663 15.8333 1.66663H14.1667C12.5 1.66663 11.6667 2.49996 11.6667 4.16663V5.83329C11.6667 7.49996 12.5 8.33329 14.1667 8.33329Z"
					stroke="black"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M4.16667 18.3333H5.83333C7.5 18.3333 8.33333 17.5 8.33333 15.8333V14.1666C8.33333 12.5 7.5 11.6666 5.83333 11.6666H4.16667C2.5 11.6666 1.66667 12.5 1.66667 14.1666V15.8333C1.66667 17.5 2.5 18.3333 4.16667 18.3333Z"
					stroke="black"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M5 8.33329C6.84095 8.33329 8.33333 6.84091 8.33333 4.99996C8.33333 3.15901 6.84095 1.66663 5 1.66663C3.15905 1.66663 1.66667 3.15901 1.66667 4.99996C1.66667 6.84091 3.15905 8.33329 5 8.33329Z"
					stroke="black"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M15 18.3333C16.8409 18.3333 18.3333 16.8409 18.3333 15C18.3333 13.159 16.8409 11.6666 15 11.6666C13.1591 11.6666 11.6667 13.159 11.6667 15C11.6667 16.8409 13.1591 18.3333 15 18.3333Z"
					stroke="black"
					strokeWidth="1.25"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		to: "",
		text: "dashboard",
		role: "",
	},

	// Admin Managment
	{
		title: "Admin Managment",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M10.4166 18.3335H3.39998C2.43331 18.3335 1.64164 17.5585 1.64164 16.6085V4.2418C1.64164 2.05846 3.26664 1.06679 5.25831 2.04179L8.95831 3.85846C9.75831 4.25013 10.4166 5.29179 10.4166 6.17513V18.3335Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M18.3083 12.5501V15.7001C18.3083 17.5001 17.475 18.3335 15.675 18.3335H10.4166V8.68347L10.8083 8.76681L14.5583 9.60847L16.25 9.98347C17.35 10.2251 18.25 10.7918 18.3 12.3918C18.3083 12.4418 18.3083 12.4918 18.3083 12.5501Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M4.58331 7.50012H7.47497"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M4.58331 10.8334H7.47497"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M14.5583 9.60839V12.2917C14.5583 13.3251 13.7166 14.1667 12.6833 14.1667C11.65 14.1667 10.8083 13.3251 10.8083 12.2917V8.76672L14.5583 9.60839Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M18.3 12.3917C18.25 13.3751 17.4333 14.1667 16.4333 14.1667C15.4 14.1667 14.5583 13.3251 14.5583 12.2917V9.6084L16.25 9.9834C17.35 10.2251 18.25 10.7917 18.3 12.3917Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M10.4166 18.3335H3.39998C2.43331 18.3335 1.64164 17.5585 1.64164 16.6085V4.2418C1.64164 2.05846 3.26664 1.06679 5.25831 2.04179L8.95831 3.85846C9.75831 4.25013 10.4166 5.29179 10.4166 6.17513V18.3335Z"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M18.3083 12.5501V15.7001C18.3083 17.5001 17.475 18.3335 15.675 18.3335H10.4166V8.68347L10.8083 8.76681L14.5583 9.60847L16.25 9.98347C17.35 10.2251 18.25 10.7918 18.3 12.3918C18.3083 12.4418 18.3083 12.4918 18.3083 12.5501Z"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M4.58331 7.50012H7.47497"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M4.58331 10.8334H7.47497"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M14.5583 9.60839V12.2917C14.5583 13.3251 13.7166 14.1667 12.6833 14.1667C11.65 14.1667 10.8083 13.3251 10.8083 12.2917V8.76672L14.5583 9.60839Z"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M18.3 12.3917C18.25 13.3751 17.4333 14.1667 16.4333 14.1667C15.4 14.1667 14.5583 13.3251 14.5583 12.2917V9.6084L16.25 9.9834C17.35 10.2251 18.25 10.7917 18.3 12.3917Z"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		text: "admin_managment",
		content: [
			// Admins
			{
				title: "Admins",
				to: "/admins",
				text: "admins",
				role: "admin_management",
			},
			// Roles
			{
				title: "Roles",
				to: "/roles",
				text: "roles",
				role: "admin_management",
			},
		],
	},

	// Category Managment
	{
		title: "Category Managment",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M18.3333 6.8915V3.52484C18.3333 2.19984 17.8 1.6665 16.475 1.6665H13.1083C11.7833 1.6665 11.25 2.19984 11.25 3.52484V6.8915C11.25 8.2165 11.7833 8.74984 13.1083 8.74984H16.475C17.8 8.74984 18.3333 8.2165 18.3333 6.8915Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.75001 7.09984V3.3165C8.75001 2.1415 8.21667 1.6665 6.89167 1.6665H3.52501C2.20001 1.6665 1.66667 2.1415 1.66667 3.3165V7.0915C1.66667 8.27484 2.20001 8.7415 3.52501 8.7415H6.89167C8.21667 8.74984 8.75001 8.27484 8.75001 7.09984Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.75001 16.475V13.1083C8.75001 11.7833 8.21667 11.25 6.89167 11.25H3.52501C2.20001 11.25 1.66667 11.7833 1.66667 13.1083V16.475C1.66667 17.8 2.20001 18.3333 3.52501 18.3333H6.89167C8.21667 18.3333 8.75001 17.8 8.75001 16.475Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.0833 14.5835H17.0833"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
				/>
				<path
					d="M14.5833 17.0835V12.0835"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M18.3333 6.8915V3.52484C18.3333 2.19984 17.8 1.6665 16.475 1.6665H13.1083C11.7833 1.6665 11.25 2.19984 11.25 3.52484V6.8915C11.25 8.2165 11.7833 8.74984 13.1083 8.74984H16.475C17.8 8.74984 18.3333 8.2165 18.3333 6.8915Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.75001 7.09984V3.3165C8.75001 2.1415 8.21667 1.6665 6.89167 1.6665H3.52501C2.20001 1.6665 1.66667 2.1415 1.66667 3.3165V7.0915C1.66667 8.27484 2.20001 8.7415 3.52501 8.7415H6.89167C8.21667 8.74984 8.75001 8.27484 8.75001 7.09984Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.75001 16.475V13.1083C8.75001 11.7833 8.21667 11.25 6.89167 11.25H3.52501C2.20001 11.25 1.66667 11.7833 1.66667 13.1083V16.475C1.66667 17.8 2.20001 18.3333 3.52501 18.3333H6.89167C8.21667 18.3333 8.75001 17.8 8.75001 16.475Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.0833 14.5835H17.0833"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
				/>
				<path
					d="M14.5833 17.0835V12.0835"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
				/>
			</svg>
		),
		to: "category-managment",
		text: "category_management",
		role: "categories",
	},
	// Vendors
	{
		title: "Vendors",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M7.63338 9.05866C7.55005 9.05033 7.45005 9.05033 7.35838 9.05866C5.37505 8.99199 3.80005 7.36699 3.80005 5.36699C3.80005 3.32533 5.45005 1.66699 7.50005 1.66699C9.54172 1.66699 11.2 3.32533 11.2 5.36699C11.1917 7.36699 9.61672 8.99199 7.63338 9.05866Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M13.675 3.33301C15.2917 3.33301 16.5917 4.64134 16.5917 6.24967C16.5917 7.82467 15.3417 9.10801 13.7834 9.16634C13.7167 9.15801 13.6417 9.15801 13.5667 9.16634"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M3.46664 12.133C1.44998 13.483 1.44998 15.683 3.46664 17.0247C5.75831 18.558 9.51664 18.558 11.8083 17.0247C13.825 15.6747 13.825 13.4747 11.8083 12.133C9.52498 10.608 5.76664 10.608 3.46664 12.133Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M15.2834 16.667C15.8834 16.542 16.4501 16.3003 16.9167 15.942C18.2167 14.967 18.2167 13.3587 16.9167 12.3837C16.4584 12.0337 15.9001 11.8003 15.3084 11.667"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M7.63338 9.05866C7.55005 9.05033 7.45005 9.05033 7.35838 9.05866C5.37505 8.99199 3.80005 7.36699 3.80005 5.36699C3.80005 3.32533 5.45005 1.66699 7.50005 1.66699C9.54172 1.66699 11.2 3.32533 11.2 5.36699C11.1917 7.36699 9.61672 8.99199 7.63338 9.05866Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M13.675 3.33301C15.2917 3.33301 16.5917 4.64134 16.5917 6.24967C16.5917 7.82467 15.3417 9.10801 13.7834 9.16634C13.7167 9.15801 13.6417 9.15801 13.5667 9.16634"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M3.46664 12.133C1.44998 13.483 1.44998 15.683 3.46664 17.0247C5.75831 18.558 9.51664 18.558 11.8083 17.0247C13.825 15.6747 13.825 13.4747 11.8083 12.133C9.52498 10.608 5.76664 10.608 3.46664 12.133Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M15.2834 16.667C15.8834 16.542 16.4501 16.3003 16.9167 15.942C18.2167 14.967 18.2167 13.3587 16.9167 12.3837C16.4584 12.0337 15.9001 11.8003 15.3084 11.667"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		to: "vendors",
		text: "vendors",
		role: "category_management",
	},
	// Popular Vendors
	{
		title: "Popular Vendors",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M7.63338 9.05866C7.55005 9.05033 7.45005 9.05033 7.35838 9.05866C5.37505 8.99199 3.80005 7.36699 3.80005 5.36699C3.80005 3.32533 5.45005 1.66699 7.50005 1.66699C9.54172 1.66699 11.2 3.32533 11.2 5.36699C11.1917 7.36699 9.61672 8.99199 7.63338 9.05866Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M13.675 3.33301C15.2917 3.33301 16.5917 4.64134 16.5917 6.24967C16.5917 7.82467 15.3417 9.10801 13.7834 9.16634C13.7167 9.15801 13.6417 9.15801 13.5667 9.16634"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M3.46664 12.133C1.44998 13.483 1.44998 15.683 3.46664 17.0247C5.75831 18.558 9.51664 18.558 11.8083 17.0247C13.825 15.6747 13.825 13.4747 11.8083 12.133C9.52498 10.608 5.76664 10.608 3.46664 12.133Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M15.2834 16.667C15.8834 16.542 16.4501 16.3003 16.9167 15.942C18.2167 14.967 18.2167 13.3587 16.9167 12.3837C16.4584 12.0337 15.9001 11.8003 15.3084 11.667"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M7.63338 9.05866C7.55005 9.05033 7.45005 9.05033 7.35838 9.05866C5.37505 8.99199 3.80005 7.36699 3.80005 5.36699C3.80005 3.32533 5.45005 1.66699 7.50005 1.66699C9.54172 1.66699 11.2 3.32533 11.2 5.36699C11.1917 7.36699 9.61672 8.99199 7.63338 9.05866Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M13.675 3.33301C15.2917 3.33301 16.5917 4.64134 16.5917 6.24967C16.5917 7.82467 15.3417 9.10801 13.7834 9.16634C13.7167 9.15801 13.6417 9.15801 13.5667 9.16634"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M3.46664 12.133C1.44998 13.483 1.44998 15.683 3.46664 17.0247C5.75831 18.558 9.51664 18.558 11.8083 17.0247C13.825 15.6747 13.825 13.4747 11.8083 12.133C9.52498 10.608 5.76664 10.608 3.46664 12.133Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M15.2834 16.667C15.8834 16.542 16.4501 16.3003 16.9167 15.942C18.2167 14.967 18.2167 13.3587 16.9167 12.3837C16.4584 12.0337 15.9001 11.8003 15.3084 11.667"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		to: "popular-vendors",
		text: "popular_vendors",
		role: "category_management",
	},
	// Vendors Requests
	// {
	// 	title: "Vendors Requests",
	// 	classsChange: "mm-collapse",
	// 	iconActive: (
	// 		<svg
	// 			width="20"
	// 			height="20"
	// 			viewBox="0 0 20 20"
	// 			fill="none"
	// 			xmlns="http://www.w3.org/2000/svg">
	// 			<path
	// 				d="M7.63338 9.05866C7.55005 9.05033 7.45005 9.05033 7.35838 9.05866C5.37505 8.99199 3.80005 7.36699 3.80005 5.36699C3.80005 3.32533 5.45005 1.66699 7.50005 1.66699C9.54172 1.66699 11.2 3.32533 11.2 5.36699C11.1917 7.36699 9.61672 8.99199 7.63338 9.05866Z"
	// 				stroke="#FFF"
	// 				strokeWidth="1.25"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 			<path
	// 				d="M13.675 3.33301C15.2917 3.33301 16.5917 4.64134 16.5917 6.24967C16.5917 7.82467 15.3417 9.10801 13.7834 9.16634C13.7167 9.15801 13.6417 9.15801 13.5667 9.16634"
	// 				stroke="#FFF"
	// 				strokeWidth="1.25"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 			<path
	// 				d="M3.46664 12.133C1.44998 13.483 1.44998 15.683 3.46664 17.0247C5.75831 18.558 9.51664 18.558 11.8083 17.0247C13.825 15.6747 13.825 13.4747 11.8083 12.133C9.52498 10.608 5.76664 10.608 3.46664 12.133Z"
	// 				stroke="#FFF"
	// 				strokeWidth="1.25"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 			<path
	// 				d="M15.2834 16.667C15.8834 16.542 16.4501 16.3003 16.9167 15.942C18.2167 14.967 18.2167 13.3587 16.9167 12.3837C16.4584 12.0337 15.9001 11.8003 15.3084 11.667"
	// 				stroke="#FFF"
	// 				strokeWidth="1.25"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		</svg>
	// 	),
	// 	iconDeactive: (
	// 		<svg
	// 			width="20"
	// 			height="20"
	// 			viewBox="0 0 20 20"
	// 			fill="none"
	// 			xmlns="http://www.w3.org/2000/svg">
	// 			<path
	// 				d="M7.63338 9.05866C7.55005 9.05033 7.45005 9.05033 7.35838 9.05866C5.37505 8.99199 3.80005 7.36699 3.80005 5.36699C3.80005 3.32533 5.45005 1.66699 7.50005 1.66699C9.54172 1.66699 11.2 3.32533 11.2 5.36699C11.1917 7.36699 9.61672 8.99199 7.63338 9.05866Z"
	// 				stroke="black"
	// 				strokeWidth="1.25"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 			<path
	// 				d="M13.675 3.33301C15.2917 3.33301 16.5917 4.64134 16.5917 6.24967C16.5917 7.82467 15.3417 9.10801 13.7834 9.16634C13.7167 9.15801 13.6417 9.15801 13.5667 9.16634"
	// 				stroke="black"
	// 				strokeWidth="1.25"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 			<path
	// 				d="M3.46664 12.133C1.44998 13.483 1.44998 15.683 3.46664 17.0247C5.75831 18.558 9.51664 18.558 11.8083 17.0247C13.825 15.6747 13.825 13.4747 11.8083 12.133C9.52498 10.608 5.76664 10.608 3.46664 12.133Z"
	// 				stroke="black"
	// 				strokeWidth="1.25"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 			<path
	// 				d="M15.2834 16.667C15.8834 16.542 16.4501 16.3003 16.9167 15.942C18.2167 14.967 18.2167 13.3587 16.9167 12.3837C16.4584 12.0337 15.9001 11.8003 15.3084 11.667"
	// 				stroke="black"
	// 				strokeWidth="1.25"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		</svg>
	// 	),
	// 	to: "vendors-requests",
	// 	text: "vendors_requests",
	// 	role: "vendors_requests",
	// },
	// Packages
	{
		title: "Packages",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="200"
				height="200"
				viewBox="0 0 24 24"
				fill="#FFF">
				<g
					fill="none"
					stroke="#FFF"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="1.5">
					<path d="m7 16.5l-5-3l5-3l5 3V19l-5 3z" />
					<path d="M2 13.5V19l5 3m0-5.455l5-3.03m5 2.985l-5-3l5-3l5 3V19l-5 3zM12 19l5 3m0-5.5l5-3m-10 0V8L7 5l5-3l5 3v5.5M7 5.03v5.455M12 8l5-3" />
				</g>
			</svg>
		),
		iconDeactive: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="20"
				height="20"
				viewBox="0 0 24 24"
				fill="#000000">
				<g
					fill="none"
					stroke="#000000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="1.5">
					<path d="m7 16.5l-5-3l5-3l5 3V19l-5 3z" />
					<path d="M2 13.5V19l5 3m0-5.455l5-3.03m5 2.985l-5-3l5-3l5 3V19l-5 3zM12 19l5 3m0-5.5l5-3m-10 0V8L7 5l5-3l5 3v5.5M7 5.03v5.455M12 8l5-3" />
				</g>
			</svg>
		),
		to: "packages",
		text: "packages",
		role: "category_management",
	},
	// Orders
	// {
	// 	title: "Orders",
	// 	classsChange: "mm-collapse",
	// 	iconActive: (
	// 		<svg
	// 			width="22"
	// 			height="22"
	// 			viewBox="0 0 24 24"
	// 			stroke="#FFF"
	// 			fill="none"
	// 			strokeWidth="2">
	// 			<circle cx="9" cy="21" r="1" />
	// 			<circle cx="20" cy="21" r="1" />
	// 			<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
	// 		</svg>
	// 	),
	// 	iconDeactive: (
	// 		<svg
	// 			width="22"
	// 			height="22"
	// 			viewBox="0 0 24 24"
	// 			stroke="#000"
	// 			fill="none"
	// 			strokeWidth="2">
	// 			<circle cx="9" cy="21" r="1" />
	// 			<circle cx="20" cy="21" r="1" />
	// 			<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
	// 		</svg>
	// 	),
	// 	to: "orders",
	// 	text: "orders",
	// 	role: "orders",
	// },
	// Add Ons
	{
		title: "Add Ons",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M7.22656 11.9422C7.22656 13.0172 8.05156 13.8839 9.07656 13.8839H11.1682C12.0599 13.8839 12.7849 13.1255 12.7849 12.1922C12.7849 11.1755 12.3432 10.8172 11.6849 10.5839L8.32656 9.41719C7.66823 9.18385 7.22656 8.82552 7.22656 7.80885C7.22656 6.87552 7.95156 6.11719 8.84323 6.11719H10.9349C11.9599 6.11719 12.7849 6.98385 12.7849 8.05885"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10 5V15"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.5 18.3327H7.5C3.33333 18.3327 1.66666 16.666 1.66666 12.4993V7.49935C1.66666 3.33268 3.33333 1.66602 7.5 1.66602H12.5C16.6667 1.66602 18.3333 3.33268 18.3333 7.49935V12.4993C18.3333 16.666 16.6667 18.3327 12.5 18.3327Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M7.22656 11.9422C7.22656 13.0172 8.05156 13.8839 9.07656 13.8839H11.1682C12.0599 13.8839 12.7849 13.1255 12.7849 12.1922C12.7849 11.1755 12.3432 10.8172 11.6849 10.5839L8.32656 9.41719C7.66823 9.18385 7.22656 8.82552 7.22656 7.80885C7.22656 6.87552 7.95156 6.11719 8.84323 6.11719H10.9349C11.9599 6.11719 12.7849 6.98385 12.7849 8.05885"
					stroke="#000"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10 5V15"
					stroke="#000"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.5 18.3327H7.5C3.33333 18.3327 1.66666 16.666 1.66666 12.4993V7.49935C1.66666 3.33268 3.33333 1.66602 7.5 1.66602H12.5C16.6667 1.66602 18.3333 3.33268 18.3333 7.49935V12.4993C18.3333 16.666 16.6667 18.3327 12.5 18.3327Z"
					stroke="#000"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		to: "add-ons",
		text: "add_ons",
		role: "add_ons",
	},
	// Booking
	{
		title: "Booking",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				fill="none"
				stroke="#FFF"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
				viewBox="0 0 24 24">
				<rect x="3" y="4" width="18" height="18" rx="2"></rect>
				<line x1="16" y1="2" x2="16" y2="6"></line>
				<line x1="8" y1="2" x2="8" y2="6"></line>
				<line x1="3" y1="10" x2="21" y2="10"></line>
				<circle cx="12" cy="15" r="2"></circle>
			</svg>
		),
		iconDeactive: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				fill="none"
				stroke="#000"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
				viewBox="0 0 24 24">
				<rect x="3" y="4" width="18" height="18" rx="2"></rect>
				<line x1="16" y1="2" x2="16" y2="6"></line>
				<line x1="8" y1="2" x2="8" y2="6"></line>
				<line x1="3" y1="10" x2="21" y2="10"></line>
				<circle cx="12" cy="15" r="2"></circle>
			</svg>
		),
		to: "bookings",
		text: "bookings",
		role: "bookings",
	},

	// Reviews
	{
		title: "Reviews",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="200"
				height="200"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24">
				<path
					fill="#FFF"
					stroke="#FFF"
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M11.757 1.221a.253.253 0 0 1 .49 0l.76 3.121h3.195a.252.252 0 0 1 .14.461l-2.329 1.482l1.22 3.254a.252.252 0 0 1-.382.293L12 7.796L9.148 9.832a.252.252 0 0 1-.383-.293l1.221-3.254l-2.33-1.482a.252.252 0 0 1 .14-.46h3.197zm6.545 13.197a.252.252 0 0 1 .49 0l.762 3.009h3.195a.252.252 0 0 1 .14.46l-2.33 1.487l1.22 3.254a.252.252 0 0 1-.383.293l-2.851-2.037l-2.853 2.037a.252.252 0 0 1-.382-.293l1.221-3.254l-2.33-1.482a.252.252 0 0 1 .14-.461h3.197zM5.213 14.31a.251.251 0 0 1 .49 0l.761 3.12H9.66a.252.252 0 0 1 .139.462l-2.33 1.482l1.22 3.254a.252.252 0 0 1-.382.293l-2.852-2.037l-2.852 2.037a.252.252 0 0 1-.382-.293l1.22-3.254l-2.329-1.482a.252.252 0 0 1 .139-.461h3.198z"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24">
				<path
					fill="#000"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M11.757 1.221a.253.253 0 0 1 .49 0l.76 3.121h3.195a.252.252 0 0 1 .14.461l-2.329 1.482l1.22 3.254a.252.252 0 0 1-.382.293L12 7.796L9.148 9.832a.252.252 0 0 1-.383-.293l1.221-3.254l-2.33-1.482a.252.252 0 0 1 .14-.46h3.197zm6.545 13.197a.252.252 0 0 1 .49 0l.762 3.009h3.195a.252.252 0 0 1 .14.46l-2.33 1.487l1.22 3.254a.252.252 0 0 1-.383.293l-2.851-2.037l-2.853 2.037a.252.252 0 0 1-.382-.293l1.221-3.254l-2.33-1.482a.252.252 0 0 1 .14-.461h3.197zM5.213 14.31a.251.251 0 0 1 .49 0l.761 3.12H9.66a.252.252 0 0 1 .139.462l-2.33 1.482l1.22 3.254a.252.252 0 0 1-.382.293l-2.852-2.037l-2.852 2.037a.252.252 0 0 1-.382-.293l1.22-3.254l-2.329-1.482a.252.252 0 0 1 .139-.461h3.198z"
				/>
			</svg>
		),
		to: "reviews",
		text: "reviews",
		role: "reviews",
	},

	// Discount
	{
		title: "Discount",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24">
				<path
					fill="#FFF"
					d="M21.953 12c0 .591-.346 1.124-.839 1.61c-.295.29-.639.568-.942.85c-.242.225-.46.446-.562.692c-.107.257-.114.576-.105.913c.011.416.056.855.059 1.265c.006.691-.123 1.304-.526 1.708c-.404.403-1.017.532-1.708.526c-.41-.004-.849-.048-1.264-.059c-.337-.009-.657-.002-.914.105c-.246.102-.467.32-.692.562c-.282.303-.56.647-.85.941c-.486.494-1.019.84-1.61.84c-.591 0-1.124-.346-1.61-.84c-.29-.294-.568-.638-.85-.941c-.225-.242-.447-.46-.692-.562c-.257-.107-.577-.114-.913-.105c-.416.011-.855.055-1.265.059c-.691.006-1.305-.123-1.708-.526c-.404-.404-.532-1.017-.526-1.708c.003-.41.048-.849.059-1.265c.009-.337.002-.656-.105-.914c-.102-.245-.32-.466-.562-.691c-.302-.282-.646-.56-.941-.85c-.493-.486-.84-1.019-.84-1.61c0-.591.347-1.124.84-1.61c.295-.29.639-.568.941-.85c.242-.225.46-.446.562-.691c.107-.258.114-.577.105-.914c-.011-.416-.056-.855-.059-1.265c-.006-.691.122-1.304.526-1.708c.403-.403 1.017-.532 1.708-.526c.41.004.849.048 1.265.059c.336.009.656.002.913-.105c.245-.102.467-.32.692-.562c.282-.303.56-.647.85-.941c.486-.494 1.019-.84 1.61-.84c.591 0 1.124.346 1.61.84c.29.294.568.638.85.941c.225.242.446.46.692.562c.257.107.577.114.914.105c.415-.011.854-.055 1.264-.059c.691-.006 1.304.123 1.708.526c.403.404.532 1.017.526 1.708c-.003.41-.048.849-.059 1.265c-.009.337-.002.656.105.913c.102.246.32.467.562.692c.303.282.647.56.942.85c.493.486.839 1.019.839 1.61Zm-1 0c0-.188-.088-.355-.206-.518c-.164-.226-.388-.437-.622-.646c-.583-.521-1.205-1.04-1.439-1.604c-.242-.585-.177-1.399-.136-2.178c.017-.315.027-.622-.015-.895c-.029-.191-.08-.365-.204-.489c-.125-.125-.299-.176-.49-.205c-.273-.042-.58-.032-.895-.015c-.779.041-1.593.106-2.177-.136c-.565-.234-1.084-.855-1.605-1.439c-.209-.234-.42-.458-.646-.622c-.163-.118-.33-.206-.518-.206c-.187 0-.355.088-.518.206c-.226.164-.437.388-.646.622c-.521.584-1.04 1.205-1.605 1.439c-.584.242-1.398.177-2.177.136c-.315-.017-.622-.027-.895.015c-.192.029-.365.08-.49.205c-.125.124-.175.298-.204.489c-.042.273-.032.58-.016.895c.042.779.107 1.593-.135 2.177c-.234.565-.855 1.084-1.439 1.605c-.234.209-.458.42-.622.646c-.118.163-.206.33-.206.518s.088.355.206.518c.164.226.388.437.622.646c.584.521 1.205 1.04 1.439 1.605c.242.584.177 1.398.135 2.177c-.016.315-.026.622.016.895c.029.191.079.365.204.489c.125.125.298.176.49.205c.273.042.58.032.895.015c.779-.041 1.593-.106 2.177.136c.565.234 1.084.855 1.605 1.439c.209.234.42.458.646.622c.163.118.331.206.518.206c.188 0 .355-.088.518-.206c.226-.164.437-.388.646-.622c.521-.584 1.04-1.205 1.605-1.439c.584-.242 1.398-.177 2.177-.136c.315.017.622.027.895-.015c.191-.029.365-.08.49-.205c.124-.124.175-.298.204-.489c.042-.273.032-.58.015-.895c-.041-.779-.106-1.593.136-2.178c.234-.564.856-1.083 1.439-1.604c.234-.209.458-.42.622-.646c.118-.163.206-.33.206-.518Zm-10.531-1.762a1.015 1.015 0 1 1-1.435-1.436a1.015 1.015 0 0 1 1.435 1.436ZM14.893 8.4a.5.5 0 0 1 .707.707L9.107 15.6a.5.5 0 0 1-.707-.707L14.893 8.4Zm-1.315 5.363a1.015 1.015 0 1 1 1.435 1.436a1.015 1.015 0 0 1-1.435-1.436Z"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24">
				<path
					fill="#000000"
					d="M21.953 12c0 .591-.346 1.124-.839 1.61c-.295.29-.639.568-.942.85c-.242.225-.46.446-.562.692c-.107.257-.114.576-.105.913c.011.416.056.855.059 1.265c.006.691-.123 1.304-.526 1.708c-.404.403-1.017.532-1.708.526c-.41-.004-.849-.048-1.264-.059c-.337-.009-.657-.002-.914.105c-.246.102-.467.32-.692.562c-.282.303-.56.647-.85.941c-.486.494-1.019.84-1.61.84c-.591 0-1.124-.346-1.61-.84c-.29-.294-.568-.638-.85-.941c-.225-.242-.447-.46-.692-.562c-.257-.107-.577-.114-.913-.105c-.416.011-.855.055-1.265.059c-.691.006-1.305-.123-1.708-.526c-.404-.404-.532-1.017-.526-1.708c.003-.41.048-.849.059-1.265c.009-.337.002-.656-.105-.914c-.102-.245-.32-.466-.562-.691c-.302-.282-.646-.56-.941-.85c-.493-.486-.84-1.019-.84-1.61c0-.591.347-1.124.84-1.61c.295-.29.639-.568.941-.85c.242-.225.46-.446.562-.691c.107-.258.114-.577.105-.914c-.011-.416-.056-.855-.059-1.265c-.006-.691.122-1.304.526-1.708c.403-.403 1.017-.532 1.708-.526c.41.004.849.048 1.265.059c.336.009.656.002.913-.105c.245-.102.467-.32.692-.562c.282-.303.56-.647.85-.941c.486-.494 1.019-.84 1.61-.84c.591 0 1.124.346 1.61.84c.29.294.568.638.85.941c.225.242.446.46.692.562c.257.107.577.114.914.105c.415-.011.854-.055 1.264-.059c.691-.006 1.304.123 1.708.526c.403.404.532 1.017.526 1.708c-.003.41-.048.849-.059 1.265c-.009.337-.002.656.105.913c.102.246.32.467.562.692c.303.282.647.56.942.85c.493.486.839 1.019.839 1.61Zm-1 0c0-.188-.088-.355-.206-.518c-.164-.226-.388-.437-.622-.646c-.583-.521-1.205-1.04-1.439-1.604c-.242-.585-.177-1.399-.136-2.178c.017-.315.027-.622-.015-.895c-.029-.191-.08-.365-.204-.489c-.125-.125-.299-.176-.49-.205c-.273-.042-.58-.032-.895-.015c-.779.041-1.593.106-2.177-.136c-.565-.234-1.084-.855-1.605-1.439c-.209-.234-.42-.458-.646-.622c-.163-.118-.33-.206-.518-.206c-.187 0-.355.088-.518.206c-.226.164-.437.388-.646.622c-.521.584-1.04 1.205-1.605 1.439c-.584.242-1.398.177-2.177.136c-.315-.017-.622-.027-.895.015c-.192.029-.365.08-.49.205c-.125.124-.175.298-.204.489c-.042.273-.032.58-.016.895c.042.779.107 1.593-.135 2.177c-.234.565-.855 1.084-1.439 1.605c-.234.209-.458.42-.622.646c-.118.163-.206.33-.206.518s.088.355.206.518c.164.226.388.437.622.646c.584.521 1.205 1.04 1.439 1.605c.242.584.177 1.398.135 2.177c-.016.315-.026.622.016.895c.029.191.079.365.204.489c.125.125.298.176.49.205c.273.042.58.032.895.015c.779-.041 1.593-.106 2.177.136c.565.234 1.084.855 1.605 1.439c.209.234.42.458.646.622c.163.118.331.206.518.206c.188 0 .355-.088.518-.206c.226-.164.437-.388.646-.622c.521-.584 1.04-1.205 1.605-1.439c.584-.242 1.398-.177 2.177-.136c.315.017.622.027.895-.015c.191-.029.365-.08.49-.205c.124-.124.175-.298.204-.489c.042-.273.032-.58.015-.895c-.041-.779-.106-1.593.136-2.178c.234-.564.856-1.083 1.439-1.604c.234-.209.458-.42.622-.646c.118-.163.206-.33.206-.518Zm-10.531-1.762a1.015 1.015 0 1 1-1.435-1.436a1.015 1.015 0 0 1 1.435 1.436ZM14.893 8.4a.5.5 0 0 1 .707.707L9.107 15.6a.5.5 0 0 1-.707-.707L14.893 8.4Zm-1.315 5.363a1.015 1.015 0 1 1 1.435 1.436a1.015 1.015 0 0 1-1.435-1.436Z"
				/>
			</svg>
		),
		text: "discount",
		to: "discount",
		role: "discount",
	},

	// Notification
	{
		title: "Notification",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M19.34 14.49L18.34 12.83C18.13 12.46 17.94 11.76 17.94 11.35V8.82C17.94 6.47 16.56 4.44 14.57 3.49C14.05 2.57 13.09 2 11.99 2C10.9 2 9.92 2.59 9.4 3.52C7.45 4.49 6.1 6.5 6.1 8.82V11.35C6.1 11.76 5.91 12.46 5.7 12.82L4.69 14.49C4.29 15.16 4.2 15.9 4.45 16.58C4.69 17.25 5.26 17.77 6 18.02C7.94 18.68 9.98 19 12.02 19C14.06 19 16.1 18.68 18.04 18.03C18.74 17.8 19.28 17.27 19.54 16.58C19.8 15.89 19.73 15.13 19.34 14.49Z"
					fill="white"
				/>
				<path
					d="M14.83 20.01C14.41 21.17 13.3 22 12 22C11.21 22 10.43 21.68 9.87999 21.11C9.55999 20.81 9.31999 20.41 9.17999 20C9.30999 20.02 9.43999 20.03 9.57999 20.05C9.80999 20.08 10.05 20.11 10.29 20.13C10.86 20.18 11.44 20.21 12.02 20.21C12.59 20.21 13.16 20.18 13.72 20.13C13.93 20.11 14.14 20.1 14.34 20.07C14.5 20.05 14.66 20.03 14.83 20.01Z"
					fill="white"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M19.34 14.49L18.34 12.83C18.13 12.46 17.94 11.76 17.94 11.35V8.82C17.94 6.47 16.56 4.44 14.57 3.49C14.05 2.57 13.09 2 11.99 2C10.9 2 9.92 2.59 9.4 3.52C7.45 4.49 6.1 6.5 6.1 8.82V11.35C6.1 11.76 5.91 12.46 5.7 12.82L4.69 14.49C4.29 15.16 4.2 15.9 4.45 16.58C4.69 17.25 5.26 17.77 6 18.02C7.94 18.68 9.98 19 12.02 19C14.06 19 16.1 18.68 18.04 18.03C18.74 17.8 19.28 17.27 19.54 16.58C19.8 15.89 19.73 15.13 19.34 14.49Z"
					fill="#7B7B7B"
				/>
				<path
					d="M14.83 20.01C14.41 21.17 13.3 22 12 22C11.21 22 10.43 21.68 9.87999 21.11C9.55999 20.81 9.31999 20.41 9.17999 20C9.30999 20.02 9.43999 20.03 9.57999 20.05C9.80999 20.08 10.05 20.11 10.29 20.13C10.86 20.18 11.44 20.21 12.02 20.21C12.59 20.21 13.16 20.18 13.72 20.13C13.93 20.11 14.14 20.1 14.34 20.07C14.5 20.05 14.66 20.03 14.83 20.01Z"
					fill="#7B7B7B"
				/>
			</svg>
		),
		to: "/notification",
		text: "notification",
		role: "notification",
	},

	// Users
	{
		title: "Users",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M7.63338 9.05866C7.55005 9.05033 7.45005 9.05033 7.35838 9.05866C5.37505 8.99199 3.80005 7.36699 3.80005 5.36699C3.80005 3.32533 5.45005 1.66699 7.50005 1.66699C9.54172 1.66699 11.2 3.32533 11.2 5.36699C11.1917 7.36699 9.61672 8.99199 7.63338 9.05866Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M13.675 3.33301C15.2917 3.33301 16.5917 4.64134 16.5917 6.24967C16.5917 7.82467 15.3417 9.10801 13.7834 9.16634C13.7167 9.15801 13.6417 9.15801 13.5667 9.16634"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M3.46664 12.133C1.44998 13.483 1.44998 15.683 3.46664 17.0247C5.75831 18.558 9.51664 18.558 11.8083 17.0247C13.825 15.6747 13.825 13.4747 11.8083 12.133C9.52498 10.608 5.76664 10.608 3.46664 12.133Z"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M15.2834 16.667C15.8834 16.542 16.4501 16.3003 16.9167 15.942C18.2167 14.967 18.2167 13.3587 16.9167 12.3837C16.4584 12.0337 15.9001 11.8003 15.3084 11.667"
					stroke="#FFF"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M7.63338 9.05866C7.55005 9.05033 7.45005 9.05033 7.35838 9.05866C5.37505 8.99199 3.80005 7.36699 3.80005 5.36699C3.80005 3.32533 5.45005 1.66699 7.50005 1.66699C9.54172 1.66699 11.2 3.32533 11.2 5.36699C11.1917 7.36699 9.61672 8.99199 7.63338 9.05866Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M13.675 3.33301C15.2917 3.33301 16.5917 4.64134 16.5917 6.24967C16.5917 7.82467 15.3417 9.10801 13.7834 9.16634C13.7167 9.15801 13.6417 9.15801 13.5667 9.16634"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M3.46664 12.133C1.44998 13.483 1.44998 15.683 3.46664 17.0247C5.75831 18.558 9.51664 18.558 11.8083 17.0247C13.825 15.6747 13.825 13.4747 11.8083 12.133C9.52498 10.608 5.76664 10.608 3.46664 12.133Z"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M15.2834 16.667C15.8834 16.542 16.4501 16.3003 16.9167 15.942C18.2167 14.967 18.2167 13.3587 16.9167 12.3837C16.4584 12.0337 15.9001 11.8003 15.3084 11.667"
					stroke="black"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		text: "users",
		to: "/users",
		role: "users",
	},

	// Subscription
	// {
	// 	title: "Subscription",
	// 	classsChange: "mm-collapse",
	// 	iconActive: (
	// 		<svg
	// 			width="20"
	// 			height="20"
	// 			viewBox="0 0 20 20"
	// 			fill="none"
	// 			xmlns="http://www.w3.org/2000/svg">
	// 			<path
	// 				d="M7.22656 11.9422C7.22656 13.0172 8.05156 13.8839 9.07656 13.8839H11.1682C12.0599 13.8839 12.7849 13.1255 12.7849 12.1922C12.7849 11.1755 12.3432 10.8172 11.6849 10.5839L8.32656 9.41719C7.66823 9.18385 7.22656 8.82552 7.22656 7.80885C7.22656 6.87552 7.95156 6.11719 8.84323 6.11719H10.9349C11.9599 6.11719 12.7849 6.98385 12.7849 8.05885"
	// 				stroke="#FFF"
	// 				strokeWidth="1.25"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 			<path
	// 				d="M10 5V15"
	// 				stroke="#FFF"
	// 				strokeWidth="1.25"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 			<path
	// 				d="M12.5 18.3327H7.5C3.33333 18.3327 1.66666 16.666 1.66666 12.4993V7.49935C1.66666 3.33268 3.33333 1.66602 7.5 1.66602H12.5C16.6667 1.66602 18.3333 3.33268 18.3333 7.49935V12.4993C18.3333 16.666 16.6667 18.3327 12.5 18.3327Z"
	// 				stroke="#FFF"
	// 				strokeWidth="1.25"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		</svg>
	// 	),
	// 	iconDeactive: (
	// 		<svg
	// 			width="20"
	// 			height="20"
	// 			viewBox="0 0 20 20"
	// 			fill="none"
	// 			xmlns="http://www.w3.org/2000/svg">
	// 			<path
	// 				d="M7.22656 11.9422C7.22656 13.0172 8.05156 13.8839 9.07656 13.8839H11.1682C12.0599 13.8839 12.7849 13.1255 12.7849 12.1922C12.7849 11.1755 12.3432 10.8172 11.6849 10.5839L8.32656 9.41719C7.66823 9.18385 7.22656 8.82552 7.22656 7.80885C7.22656 6.87552 7.95156 6.11719 8.84323 6.11719H10.9349C11.9599 6.11719 12.7849 6.98385 12.7849 8.05885"
	// 				stroke="#292D32"
	// 				strokeWidth="1.25"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 			<path
	// 				d="M10 5V15"
	// 				stroke="#292D32"
	// 				strokeWidth="1.25"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 			<path
	// 				d="M12.5 18.3327H7.5C3.33333 18.3327 1.66666 16.666 1.66666 12.4993V7.49935C1.66666 3.33268 3.33333 1.66602 7.5 1.66602H12.5C16.6667 1.66602 18.3333 3.33268 18.3333 7.49935V12.4993C18.3333 16.666 16.6667 18.3327 12.5 18.3327Z"
	// 				stroke="#292D32"
	// 				strokeWidth="1.25"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		</svg>
	// 	),
	// 	text: "subscription",
	// 	content: [
	// 		{
	// 			title: "Packages",
	// 			to: "/packages",
	// 			text: "packages",
	// 			role: "packages",
	// 		},
	// 		{
	// 			title: "Subscription",
	// 			to: "/subscription",
	// 			text: "subscription",
	// 			role: "subscription",
	// 		},
	// 	],
	// },

	// Reports
	// {
	// 	title: "Reports",
	// 	classsChange: "mm-collapse",
	// 	iconActive: (
	// 		<svg
	// 			width="20"
	// 			height="20"
	// 			viewBox="0 0 20 20"
	// 			fill="none"
	// 			xmlns="http://www.w3.org/2000/svg">
	// 			<path
	// 				d="M17.5 5.83366V14.167C17.5 16.667 16.25 18.3337 13.3333 18.3337H6.66667C3.75 18.3337 2.5 16.667 2.5 14.167V5.83366C2.5 3.33366 3.75 1.66699 6.66667 1.66699H13.3333C16.25 1.66699 17.5 3.33366 17.5 5.83366Z"
	// 				stroke="#FFF"
	// 				strokeWidth="1.25"
	// 				strokeMiterlimit="10"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 			<path
	// 				d="M12.0833 3.75V5.41667C12.0833 6.33333 12.8333 7.08333 13.75 7.08333H15.4167"
	// 				stroke="#FFF"
	// 				strokeWidth="1.25"
	// 				strokeMiterlimit="10"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 			<path
	// 				d="M6.66667 10.833H10"
	// 				stroke="#FFF"
	// 				strokeWidth="1.25"
	// 				strokeMiterlimit="10"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 			<path
	// 				d="M6.66667 14.167H13.3333"
	// 				stroke="#FFF"
	// 				strokeWidth="1.25"
	// 				strokeMiterlimit="10"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		</svg>
	// 	),
	// 	iconDeactive: (
	// 		<svg
	// 			width="20"
	// 			height="20"
	// 			viewBox="0 0 20 20"
	// 			fill="none"
	// 			xmlns="http://www.w3.org/2000/svg">
	// 			<path
	// 				d="M17.5 5.83366V14.167C17.5 16.667 16.25 18.3337 13.3333 18.3337H6.66667C3.75 18.3337 2.5 16.667 2.5 14.167V5.83366C2.5 3.33366 3.75 1.66699 6.66667 1.66699H13.3333C16.25 1.66699 17.5 3.33366 17.5 5.83366Z"
	// 				stroke="#292D32"
	// 				strokeWidth="1.25"
	// 				strokeMiterlimit="10"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 			<path
	// 				d="M12.0833 3.75V5.41667C12.0833 6.33333 12.8333 7.08333 13.75 7.08333H15.4167"
	// 				stroke="#292D32"
	// 				strokeWidth="1.25"
	// 				strokeMiterlimit="10"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 			<path
	// 				d="M6.66667 10.833H10"
	// 				stroke="#292D32"
	// 				strokeWidth="1.25"
	// 				strokeMiterlimit="10"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 			<path
	// 				d="M6.66667 14.167H13.3333"
	// 				stroke="#292D32"
	// 				strokeWidth="1.25"
	// 				strokeMiterlimit="10"
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 			/>
	// 		</svg>
	// 	),
	// 	text: "reports",
	// 	content: [
	// 		{
	// 			title: "Matches",
	// 			to: "/matches-reports",
	// 			text: "matches",
	// 			role: "reports",
	// 		},
	// 		// {
	// 		// 	title: "Tournaments",
	// 		// 	to: "/tournaments",
	// 		// 	text: "tournaments",
	// 		// },
	// 		{
	// 			title: "Booking",
	// 			to: "/booking-reports",
	// 			text: "booking",
	// 			role: "reports",
	// 		},
	// 		{
	// 			title: "Subscriptions",
	// 			to: "/subscription-reports",
	// 			text: "subscriptions",
	// 			role: "reports",
	// 		},
	// 		{
	// 			title: "Users",
	// 			to: "/users-reports",
	// 			text: "users",
	// 			role: "reports",
	// 		},
	// 	],
	// },

	// CMS
	{
		title: "CMS",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M7.5 10.834C6.95 11.109 6.49167 11.5173 6.15 12.0257C5.95833 12.3173 5.95833 12.684 6.15 12.9757C6.49167 13.484 6.95 13.8923 7.5 14.1673"
					stroke="white"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.675 10.834C13.225 11.109 13.6833 11.5173 14.025 12.0257C14.2167 12.3173 14.2167 12.684 14.025 12.9757C13.6833 13.484 13.225 13.8923 12.675 14.1673"
					stroke="white"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M7.5 18.3327H12.5C16.6667 18.3327 18.3333 16.666 18.3333 12.4993V7.49935C18.3333 3.33268 16.6667 1.66602 12.5 1.66602H7.5C3.33333 1.66602 1.66667 3.33268 1.66667 7.49935V12.4993C1.66667 16.666 3.33333 18.3327 7.5 18.3327Z"
					stroke="white"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M1.85833 6.67435L17.875 6.66602"
					stroke="white"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M7.5 10.833C6.95 11.108 6.49167 11.5163 6.15 12.0247C5.95833 12.3163 5.95833 12.683 6.15 12.9747C6.49167 13.483 6.95 13.8913 7.5 14.1663"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.675 10.833C13.225 11.108 13.6833 11.5163 14.025 12.0247C14.2167 12.3163 14.2167 12.683 14.025 12.9747C13.6833 13.483 13.225 13.8913 12.675 14.1663"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M7.5 18.3337H12.5C16.6667 18.3337 18.3333 16.667 18.3333 12.5003V7.50033C18.3333 3.33366 16.6667 1.66699 12.5 1.66699H7.5C3.33333 1.66699 1.66667 3.33366 1.66667 7.50033V12.5003C1.66667 16.667 3.33333 18.3337 7.5 18.3337Z"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M1.85833 6.67533L17.875 6.66699"
					stroke="#292D32"
					strokeWidth="1.25"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		to: "",
		text: "cms",
		content: [
			// Banner
			{
				title: "Banner",
				to: "/banner",
				text: "banner",
				role: "cms",
			},
			// About
			{
				title: "About Us",
				to: "/about",
				text: "about_us",
				role: "cms",
			},
			// Privacy
			{
				title: "Privacy",
				to: "/privacy",
				text: "privacy",
				role: "cms",
			},
			// FAQ
			{
				title: "FAQs",
				to: "/faqs",
				text: "faqs",
				role: "cms",
			},
			// Contact
			{
				title: "contact",
				to: "/contact",
				text: "contact",
				role: "cms",
			},
			// Terms Conditions
			{
				title: "Terms Conditions",
				to: "/terms",
				text: "terms_conditions",
				role: "cms",
			},
		],
	},
];
